// Ждёт подтверждения почты после регистрации и входит сам: ссылку из письма часто открывают в другом
// браузере (из Android-приложения — всегда), а игрок возвращается в игру и сразу оказывается в замке.
import { post } from '@/api/client';
import type { SessionResponse } from '@/api/types';
import { clearPendingVerify, pendingVerifyToken } from '@/lib/pendingVerify';
import { startSession } from '@/pages/auth/session';
import { useGame } from '@/store/game';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function VerifyWatcher() {
  const user = useGame((s) => s.user);
  const navigate = useNavigate();
  useEffect(() => {
    // Вошли иначе (например, по ссылке в этом же браузере) — секрет не трогаем: Android-приложение делит
    // хранилище с Chrome и ещё может им воспользоваться; он исчезнет после входа через него или при выходе
    if (user || !pendingVerifyToken()) return;
    let stopped = false;
    let busy = false;
    const check = async () => {
      const pollToken = pendingVerifyToken();
      if (stopped || busy || !pollToken || document.visibilityState === 'hidden') return;
      busy = true;
      try {
        const r = await post<SessionResponse | { pending: true }>(
          '/auth/verify-poll',
          { pollToken },
          { auth: false },
        );
        if (!stopped && 'accessToken' in r) {
          stopped = true;
          clearPendingVerify();
          await startSession(r);
          navigate('/game', { replace: true });
        }
      } catch {
        // секрет устарел (вход уже выполнен или прошло 2 суток) — остаётся вход с паролем
        clearPendingVerify();
      } finally {
        busy = false;
      }
    };
    void check();
    const id = window.setInterval(check, 4000);
    const onVisible = () => void check();
    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener('focus', onVisible);
    return () => {
      stopped = true;
      window.clearInterval(id);
      document.removeEventListener('visibilitychange', onVisible);
      window.removeEventListener('focus', onVisible);
    };
  }, [user, navigate]);
  return null;
}
